import { render, staticRenderFns } from "./LanguageDialog.vue?vue&type=template&id=d724b690&"
import script from "./LanguageDialog.vue?vue&type=script&lang=js&"
export * from "./LanguageDialog.vue?vue&type=script&lang=js&"
import style0 from "./LanguageDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports